import { doPost2, doGet2, API } from './common'

const baseUrl = '/receiptVerification'

export const getSubmissionStatus = async payload => {
  let resp = await doGet2(`${baseUrl}/status`, payload)
  let data = await resp.json()
  return data
}

//Request that the api send a reminder email to user later on.
export const requestEmailReminder = (
  breakId,
  stepId,
  receiptId,
  email,
  link,
) => {
  try {
    const payload = {
      breakId: breakId,
      stepId: stepId,
      receiptId: receiptId,
      email: email,
      link: link,
    }

    return doPost2(`${baseUrl}/schedule`, payload)
  } catch (e) {
    console.log(`Error in requestEmailReminder: ${e}`)
    return
  }
}

//Request that the api send a reminder email or sms to user later on.
export const requestEmailSMSReminder = (
  breakId,
  stepId,
  receiptId,
  email,
  phoneNumber,
  type,
  link,
  turnstileToken,
) => {
  try {
    const payload =
      email.length !== 0
        ? {
            breakId: breakId,
            stepId: stepId,
            receiptId: receiptId,
            type: type,
            email: email,
            link: link,
            turnstileToken: turnstileToken,
          }
        : {
            breakId: breakId,
            stepId: stepId,
            receiptId: receiptId,
            type: type,
            phoneNumber: phoneNumber,
            link: link,
            turnstileToken: turnstileToken,
          }

    return doPost2(`${baseUrl}/schedule`, payload)
  } catch (e) {
    console.log(`Error in requestEmailSMSReminder: ${e}`)
    return
  }
}

export const removeAttachment = (
  breakId,
  stepId,
  receiptId,
  receiptSubmissionId,
  receiptAttachmentId,
) => {
  let payload = {
    breakId: breakId,
    stepId: stepId,
    receiptId: receiptId,
    receiptSubmissionId: receiptSubmissionId,
    receiptAttachmentId: receiptAttachmentId,
  }

  return doPost2(`/receiptVerification/removeAttachment`, payload)
}

export const submitReceiptSubmission = payload => {
  return doPost2(`/receiptVerification/submit`, payload)
}

/* 
Usage:
    postFormWithProgress('/path', formData:FormData, handleProgress)
    .then((result) => {
        handleDone(true)
    }).catch((error) => {
        handleDone(false)
    })

returns a Promise

TODO: every other service method takes in params, whereas this takes in a FormData. 
Update this to be consistent with others? And move this method into common.js 
*/
export const postFormWithProgress = (path, formData, onProgress) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()

    xhr.upload.addEventListener('progress', event => {
      console.log(`progress`, event.loaded / event.total)
      if (event.lengthComputable) {
        onProgress && onProgress((event.loaded / event.total) * 100)
      }
    })

    xhr.onreadystatechange = function () {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        const status = xhr.status
        if (status === 0 || (status >= 200 && status < 400)) {
          resolve(xhr.response)
        } else {
          reject(xhr.response)
        }
      }
    }
    console.log(`begin uploading receipt image`)
    xhr.open('POST', `${process.env.DAILYBREAK_API_URL}${path}`)
    // console.log(`token`, API.getToken())
    if (API.getToken()) {
      xhr.setRequestHeader('Authorization', `Token: ${API.getToken()}`)
    }
    
    if (API.getSite()) {
        xhr.setRequestHeader('x-btm-site', `${API.getSite()}`)
    }
    xhr.withCredentials = true
    xhr.send(formData)
  })
}

export const getReceiptStatus = (page, size) => {
  let payload = {
    page,
    size,
  }

  return doGet2(`${baseUrl}/myReceipts`, payload)
}
